import { Directive, ElementRef, AfterViewChecked } from '@angular/core';

@Directive({
    selector: '[appSquare]'
})
export class SquareDirective implements AfterViewChecked {
    constructor(private el: ElementRef) { }

    // region Lifecycle Hooks
    ngAfterViewChecked(): void {
        this.el.nativeElement.style.minHeight = this.el.nativeElement.clientWidth + 'px';
    }
    // endregion
}


// WEBPACK FOOTER //
// D:/a/29/s/PDMI.PharmacyLocator.Web/src/lib/shared/square.directive.ts